import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useLayoutEffect(() => {
        // Keep the browser from automatically trying to restore scroll
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // Temporarily disable global CSS "scroll-behavior: smooth"
        // This forces the browser to snap instantly instead of animating the route change
        document.documentElement.style.scrollBehavior = 'auto';

        if (!hash) {
            // Synchronous reset directly on layout
            window.scrollTo(0, 0);

            // Give it 100ms for images to paint, do one last check, then restore smooth scrolling
            const timeout = setTimeout(() => {
                window.scrollTo(0, 0);
                document.documentElement.style.scrollBehavior = '';
            }, 100);

            return () => {
                clearTimeout(timeout);
                document.documentElement.style.scrollBehavior = '';
            };
        } else {
            document.documentElement.style.scrollBehavior = '';
        }
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
